import * as Sentry from "@sentry/react";

function ErrorFallback() {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center gap-4 text-center px-6" dir="rtl">
      <div className="text-5xl">😅</div>
      <h1 className="text-2xl font-bold tracking-tight text-foreground">
        משהו השתבש
      </h1>
      <p className="text-muted-foreground text-base">
        נסה לרענן את הדף
      </p>
      <button
        onClick={() => window.location.reload()}
        className="mt-2 px-6 py-2 rounded-lg bg-accent text-accent-foreground font-semibold text-sm uppercase tracking-[0.1em] hover:opacity-90 transition-opacity"
      >
        רענן
      </button>
    </div>
  );
}

interface SentryErrorBoundaryProps {
  children: React.ReactNode;
}

function SentryErrorBoundary({ children }: SentryErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}

export default SentryErrorBoundary;
